module.exports = __webpack_public_path__ + "static/img/__8975.1214621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8975.jpg
// module id = fVLI
// module chunks = 0